import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { ArrowUp } from '@/domains/core/tamagoshi/icons/ArrowUp';

import { seeLess, seeMore } from './translations';

import styles from './SeeMore.module.scss';

interface SeeMoreProps {
  className?: string;
  active?: boolean;
  onClick?(): void;
}

export const SeeMore: FunctionComponent<SeeMoreProps> = ({
  className,
  active = false,
  onClick,
}) => {
  const rootClassnames = classnames(
    styles.root,
    { [styles.active]: active },
    className,
  );

  return (
    <button type="button" className={rootClassnames} onClick={onClick}>
      <ArrowUp className={styles.icon} viewBox="2 2 20 20" />
      {active ? seeLess : seeMore}
    </button>
  );
};

SeeMore.displayName = 'SeeMore';
